import { coreState } from '../stores/core.js';

export function useToast() {
    function showToast(message, type = 'success') {
        if (coreState.toast.timeoutId) clearTimeout(coreState.toast.timeoutId);
        coreState.toast.visible = true;
        coreState.toast.message = message;
        coreState.toast.type = type;
        coreState.toast.timeoutId = setTimeout(() => {
            coreState.toast.visible = false;
        }, 3000);
    }

    function hideToast() {
        coreState.toast.visible = false;
    }

    return {
        showToast,
        hideToast
    };
}
